const isDesktop = () => {
  return window.innerWidth >= 990;
};

const setTocTop = () => {
  const sidebar = document.querySelector(".content-sidebar");

  if (!sidebar) return;

  if (!isDesktop()) {
    sidebar.style.top = "0";
    return;
  }

  const topPosition = 200;
  sidebar.style.setProperty('top', `${topPosition}px`, 'important');
};

let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(setTocTop, 100);
});

window.addEventListener("load", setTocTop);
document.addEventListener("DOMContentLoaded", setTocTop);

setTimeout(setTocTop, 200);
